@if (sessionGroup) {
  <div [class.remote-app-active]="isSessionActive()"
    class="dropdown remote-app-icon-bg remote-app-hover">
    <div class="flex-col align-center-center"
      (click)="onSessionClick(sessionGroup.sessionList[0])">
      <div class="remote-app flex-col align-center-center">
        @if (sessionGroup.thumbnail) {
          <img [src]="sessionGroup.thumbnail"
            width="32"
            height="32" class="remote-app-img" loading="lazy"/>
        } @else {
          <img src="assets/icons/hourglass.png" width="32" height="32" class="remote-app-img"/>
        }
      </div>
      <div class="remote-app-open-indicator-space"
        [class.remote-app-open-indicator]="true"
        [class.remote-app-open-indicator-active]="isSessionActive()">
      </div>
      <div class="remote-app-grouped-bg">
      </div>
    </div>
    <div class="dropdown-content fuse-navy-900">
      <div class="flex-col align-start-stretch">
        @for (session of sessionGroup.sessionList; track session) {
          <app-session-single
            [activeSession]="activeSession"
            (sessionClick)="onSessionClick($event)"
            [grouped]="true"
            [session]="session">
          </app-session-single>
        }
      </div>
    </div>
  </div>
}